import { IComponentOptions } from "angular";
import { UserPropertyComponentController } from "./controller";

export const vsComponentName = "userPropertyComponent";

export const userPropertyComponentOptions: IComponentOptions = {
  controller: UserPropertyComponentController,
  controllerAs: "userPropertyComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    properties: "<",
    userProperties: "<",
    user: "<",
  },
};
